<script type="text/jsx">
import ConfigBase from '@/components/config-base.vue';
import { mapGetters } from 'vuex';
import { getMessageStringByRules } from '@/views/config/partner-refer/helper/validator';
import trackingMixin from '@/views/config/partner-refer/tracking/mx';
import distributePlanLicenseMixin from '@/views/config/partner-refer/mixin/distribute-plan-license';
import { getPartnerImageFileInfo, replaceOfferDetailWithImageLink } from '@/views/config/partner-refer/helper/utils';

export default {
  extends: ConfigBase,
  mixins: [trackingMixin, distributePlanLicenseMixin],
  data() {
    return {
      configBaseClass: 'opc-partner-plan-card__wrapper',
      partnerLogoLink: '',
      showEditAction: false,
      editAriaLabel: ''
    };
  },
  computed: {
    ...mapGetters(['partnerRefer', 'partnerMessageLoading']),
    hasSelectedPlan() {
      return true;
    },
    planCardHeader() {
      const content = getMessageStringByRules(this.partnerRefer.planCardHeader);
      return this.replaceContentWithDynamicQuantity(content);
    },
    planCardContent() {
      const content = getMessageStringByRules(this.partnerRefer.planCardContent);
      return this.replaceContentWithDynamicQuantity(content);
    },
    planCardLogo() {
      const content = getMessageStringByRules(this.partnerRefer.planCardLogo);
      return replaceOfferDetailWithImageLink(content, /\${planCardLogo}/g, getPartnerImageFileInfo()?.planCardLogo);
    },
  },
  methods: {
    mx_renderHeadLeft() {
      return <div className="opc-zm-base-card__head-left" domPropsInnerHTML={this.planCardLogo} />;
    },
    mx_renderHeadRight() {
      return <div class="opc-zm-base-card__head-right" domPropsInnerHTML={this.planCardHeader} />;
    },
    mx_renderMain() {
      return <div class="opc-zm-base-card__main" domPropsInnerHTML={this.planCardContent}></div>;
    },
    mx_renderTileInner() {
      return <div>
        {this.mx_renderTopAlert()}
        {this.mx_renderFoldAble([
          this.mx_renderHead(),
          this.mx_renderDivideLine(),
          this.mx_renderMain(),
        ])}
      </div>
    }
  },
  render() {
    const configBaseClass = this.configBaseClass;

    return <tile class={`opc-zm-base-card ${configBaseClass}`}>
      {this.mx_renderTileInner()}
    </tile>;
  },
  mounted() {
    this.editAriaLabel = `${this.partnerRefer?.partnerName} plan`;
  },
};
</script>
